import React from 'react';
import { Parser as HtmlToReactParser } from 'html-to-react';
import pdfPopupToOptgroup from '../modules/pdf-popup-to-optgroup';

const htmlToReactParser = new HtmlToReactParser();

const Dropdown = (props) => {
  const { id, className, options, tooltip, initial, onChange, selectedValue } = props;

  function renderOptions(list) {
    if (Array.isArray(list) && Array.isArray(list[0])) {
      return list.map((item, index) => {
        const value = item[1];
        const label = item[0];
        return <option key={`dd-${id}-${index}`} value={value}>{label}</option>;
      });
    }
    if (Array.isArray(list) && typeof list[0] === 'object' && list[0].cName) {
      const html = pdfPopupToOptgroup(list);
      return htmlToReactParser.parse(html);
    }
  }

  function getDefaultValue() {
    return selectedValue || '';
  }

  function getInitial() {
    if (initial) {
      return <option value={initial[1]}>{initial[0]}</option>;
    }
  }

  return (
    <select
      value={getDefaultValue()}
      id={id}
      className={className || ''}
      data-tooltip={tooltip || ''}
      onChange={onChange}
    >
      {getInitial()}
      {renderOptions(options)}
    </select>
  );
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Dropdown.js